export class MessaggioChat {
    id: number = 0;
    messaggio: string = "";
    dataOra: string = "";
    inviatoDaTecnico: boolean = false;
    praticaId: number = 0;
}